<script setup lang="ts">
/**
 * Halaman varian target ukuran foto (mis. /kompres-foto/200kb), tema v3.
 *
 * Isi & metadata seluruhnya dari utils/varianKompres.ts — sumber yang SAMA
 * dengan versi produksi, jadi salinan SEO-nya mustahil bercabang. Canonical
 * tetap menunjuk alamat produksi selama v3 masih prototipe (lihat catatan di
 * v3/kompres-foto/index.vue).
 */
import { VARIAN_FOTO } from '~/utils/varianKompres'

/** Layout `ringan` — lihat catatan di pages/kompres-foto/index.vue. */
definePageMeta({ layout: 'ringan' })

const route = useRoute()
const situs = useSitusUrl()

const slug = String(route.params.target || '')
const varian = VARIAN_FOTO[slug]

if (!varian) {
  throw createError({ statusCode: 404, statusMessage: 'Halaman tidak ditemukan', fatal: true })
}

const path = `/kompres-foto/${slug}`

pakaiSeo({
  judul: varian.judul,
  deskripsi: varian.deskripsi,
  path,
  jsonLd: [
    jsonLdAplikasi({
      nama: varian.h1,
      deskripsi: varian.deskripsi,
      url: situs + path,
      harga: 0
    }),
    jsonLdFaq(varian.faq),
    jsonLdRemah(situs, [
      ['Beranda', '/'],
      ['Kompres Foto', '/kompres-foto'],
      [`${varian.targetKb} KB`, path]
    ])
  ]
})

const lainnya = Object.entries(VARIAN_FOTO)
  .filter(([s]) => s !== slug)
  .map(([s, v]) => ({ ke: `/kompres-foto/${s}`, label: `${v.targetKb} KB` }))
</script>

<template>
  <RinganVarianKompres
    jenis="foto"
    :varian="varian!"
    induk-path="/kompres-foto"
    induk-nama="Kompres Foto"
  >
    <template #tautan-lain>
      <div class="flex flex-wrap gap-3">
        <RinganTombol
          v-for="l in lainnya"
          :key="l.ke"
          variant="secondary"
          size="md"
          :to="l.ke"
        >Kompres foto jadi {{ l.label }}</RinganTombol>
      </div>
      <p class="ca-caption text-muted mt-5">
        Butuh PDF?
        <NuxtLink
          to="/kompres-pdf"
          class="text-brand font-semibold underline underline-offset-2"
        >Kompres PDF ke ukuran KB</NuxtLink>.
      </p>
    </template>
  </RinganVarianKompres>
</template>
